module.exports = __webpack_public_path__ + "img/festival_banner.daff9685.jpg";